const ErrorStatus = ({ message = "Ocorreu um erro" }) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        backgroundColor: '#fee2e2',
        color: '#991b1b',
        borderRadius: '8px'
    }}>
        ❌
        <span>{message}</span>
    </div>
);

export default ErrorStatus;